let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("lADZV")).then(() => parcelRequire('l27r9'));